var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2354",
    "data-name": "Rectangle 2354",
    width: 33,
    height: 27,
    transform: "translate(0.085 0)",
    fill: "#99abb3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10510",
    "data-name": "Group 10510",
    transform: "translate(-0.085 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10509",
    "data-name": "Group 10509",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27862",
    "data-name": "Path 27862",
    d: "M28.5,0H4.5A4.5,4.5,0,0,0,0,4.5v18A4.5,4.5,0,0,0,4.5,27h24A4.5,4.5,0,0,0,33,22.5V4.5A4.5,4.5,0,0,0,28.5,0M4.5,3h24a1.477,1.477,0,0,1,.494.084L16.5,13.08l-12.494-10A1.469,1.469,0,0,1,4.5,3M30,22.5A1.5,1.5,0,0,1,28.5,24H4.5A1.5,1.5,0,0,1,3,22.5V6.121L15.562,16.172a1.5,1.5,0,0,0,1.875,0L30,6.121Z",
    transform: "translate(0 0)",
    fill: "#99abb3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail_icon.38a6cb52dd6429b63a7510cb3f70eaca.svg";
export { ForwardRef as ReactComponent };